import type { ConnectorListItem } from 'containers/jobsiteConfiguration/tabs/connectors/connectorTypes';
import React from 'react';
import { connectorCatalog } from './connectorCatalog';

type ConnectorDetailsDrawerProps = {
  open: boolean;
  connector: ConnectorListItem | null;
  onClose: () => void;
  onAfterLeave: () => void;
  onUpdated: () => Promise<unknown>;
};

export function ConnectorDetailsDrawer({
  connector,
  open,
  onAfterLeave,
  ...props
}: ConnectorDetailsDrawerProps): React.ReactElement | null {
  const lastConnector = React.useRef<ConnectorListItem | null>(null);
  if (connector) lastConnector.current = connector;
  const renderedConnector = connector ?? lastConnector.current;
  if (!renderedConnector) return null;
  if (renderedConnector.definition.type !== renderedConnector.type)
    throw new Error(
      `Connector definition ${renderedConnector.definition.type} does not match Connector ${renderedConnector.type}`,
    );
  const { DetailsDrawer } = connectorCatalog.getEntry(renderedConnector.type);

  return (
    <DetailsDrawer
      key={renderedConnector.id}
      {...props}
      connector={renderedConnector}
      open={open}
      onAfterLeave={() => {
        lastConnector.current = null;
        onAfterLeave();
      }}
    />
  );
}
